import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const MediaLibraryComponent = lazy(() =>
  import("@scenes/MediaLibrary/components/MediaLibrary/MediaLibrary").then((module) => ({
    default: module.MediaLibrary,
  }))
);

export const mediaLibraryNRO: NavigationRoutingObject = {
  Component: MediaLibraryComponent,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "templates",
  heading: (t: I18nT<"dashboard-navigation">) => t("media-library", "Media Library"),
  pageNameForTracking: () => "Media Library",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("media-library-templates-nav", "Manage all of your images and GIFs in one place"),
  icon: "nav-system-media-library",
  getDeveloperNavigationAllowed: () => true,
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [
        t("media-library-alt-keyword-1", "AI image generator"),
        t("media-library-alt-keyword-2", "crop image"),
        t("media-library-alt-keyword-3", "upload files"),
        t("media-library-alt-keyword-4", "images"),
        t("media-library-alt-keyword-5", "fonts"),
        t("media-library-alt-keyword-6", "css"),
        t("media-library-alt-keyword-7", "js"),
      ],
    },
  ],
  additionalSearchableFeatures: () => ({}),
};
